import { DashboardScope } from '@api/domain/types';

import {
  DashboardDrilldownMachineScreenName,
  DashboardDrilldownCustomerScreenName,
  DashboardDrilldownPartScreenName,
  DashboardDrilldownNcFileScreenName,
} from '@v2/pages/dashboard/navigation/config';
import { DashboardEntityScreenTarget } from '@v2/pages/dashboard/common/types/navigation';

export const DASHBOARD_ENTITY_SCREEN_BY_SCOPE: Record<DashboardScope, (id: string, name: string) => DashboardEntityScreenTarget> = {
  [DashboardScope.Machine]: (id, name) => ({ screenName: DashboardDrilldownMachineScreenName, params: { drilldownId: id, drilldownName: name } }),
  [DashboardScope.Customer]: (id, name) => ({ screenName: DashboardDrilldownCustomerScreenName, params: { drilldownId: id, drilldownName: name } }),
  [DashboardScope.Part]: (id, name) => ({ screenName: DashboardDrilldownPartScreenName, params: { drilldownId: id, drilldownName: name } }),
  [DashboardScope.NcFile]: (id, name) => ({ screenName: DashboardDrilldownNcFileScreenName, params: { ncFileId: id, ncFileName: name } }),
};
